export const getThreeEAppStripProxiedImageUrl = (sourceUrl: string): string | null => {
    let upstreamUrl: URL;

    try {
        upstreamUrl = new URL(sourceUrl);
    } catch {
        return null;
    }

    if ((upstreamUrl.protocol !== "https:") ||
        (upstreamUrl.host.toLowerCase() !== "www.3eonline.com")) {
        return null;
    }

    const normalizedPath = upstreamUrl.pathname.replace(/\/+/g, "/");
    const pathMatch = /^\/Content\/images\/([A-Za-z0-9_-]+\.svg)$/i.exec(normalizedPath);

    return pathMatch === null
        ? null
        : `/three-e-appstrip-assets/images/${pathMatch[1]}`;
};

export const rewriteThreeEAppStripImageUrls = (appStrip: HTMLElement) => {
    appStrip.querySelectorAll<HTMLImageElement>("img[src]").forEach(image => {
        const sourceUrl = image.getAttribute("src");
        if (sourceUrl === null) {
            return;
        }

        const proxiedUrl = getThreeEAppStripProxiedImageUrl(sourceUrl);
        if (proxiedUrl !== null) {
            image.setAttribute("src", proxiedUrl);
        }
    });
};
